import { Static, Type } from '@sinclair/typebox'
import { AiBuilderText } from './ai-builder-text'
import { TurnChanges } from './turn-changes'

export const AiBuilderResponseMessage = Type.Object({
    body: AiBuilderText,
    /**
     * Free text written by the model, shown above `body` and never
     * translated. A separate field: concatenated with `body`, the string would
     * no longer be a key and would render untranslated.
     */
    prefix: Type.Optional(Type.String()),
    /**
     * What the turn changed in the flow, read from the persisted flow, never
     * from the model's prose. Absent when the turn wrote nothing.
     */
    changes: Type.Optional(TurnChanges),
})

export type AiBuilderResponseMessage = Static<typeof AiBuilderResponseMessage>
